module.exports = __webpack_public_path__ + "img/LUB00421.f0cd7cb6.png";